import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  inactiveRow: {
    opacity: 0.5
  }
});
